(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('favouritesSvc', favouritesSvc)

  function favouritesSvc(ApiSvc, $q, dataSvc, toastSvc){
    var svc = this
    svc.get = get
    svc.getPath = getPath
    svc.explore = explore
    svc.search = search
    svc.add = add
    svc.remove = remove

    ///////////

    function get(staffID){
      var deferred = $q.defer(),
        fetchScope = {}

      ApiSvc.fetch(fetchScope,{fetchAPI:'callresult/NetOwnerFavourites?pStaffID='+staffID,fetchTarget:'rawFavourites',multiRow:true})
      .then(function(){
        process(deferred, staffID, fetchScope.rawFavourites)
      })
      return deferred.promise
    }

    function process(deferred, staffID, rawFavourites){
      dataSvc.favourites[staffID] = []
      angular.forEach(rawFavourites, function(value) {
        dataSvc.favourites[staffID].push({
          name:value.favouriteName,
          id:value.favouriteID,
          description:value.favouriteDescription,
          type:value.favouriteType,
          objectID:value.objectID,
          parentID:value.parentFavouriteID,
          hasChildren:!!value.isNode
        })
        if(value.isNode && value.favouriteType !== "Heading"){ // if the item has children and is not a heading then create a folder for its children
          dataSvc.favourites[staffID].push({
            name:value.favouriteName,
            id:value.favouriteID,
            description:value.favouriteDescription,
            type:"Heading",
            objectID:null,
            parentID:value.parentFavouriteID,
            hasChildren:!!value.isNode
          })
        }
      })
      return deferred.resolve()
    }

    function getPath(item, staffID){
      var path = []
      function addParentsToPath(parentID, path){ // recursive function used to get all the parents and add them to path object
        if(!parentID || parentID === ""){ return }
        angular.forEach(dataSvc.favourites[staffID], function(value) {
          if(value.id === parentID){
            path.push({
              id:value.id,
              name:value.name
            })
            addParentsToPath(value.parentID, path)
          }
        })
      }

      addParentsToPath(item.parentID, path)
      path.push({id:"", name:"Home"})
      path.reverse()
      return path
    }

    function explore(id, staffID){
      var items = []
      angular.forEach(dataSvc.favourites[staffID], function(value) {
        if(value.parentID === id){ items.push(value) }
      })
      items.sort(sortItems)
      return items
    }

    function search(staffID, searchValue){
      var items = [],
        searchValue=searchValue || ""
      
      var searchValue = searchValue.toLowerCase()
      angular.forEach(dataSvc.favourites[staffID], function(value) {
        if(value.name.toLowerCase().includes(searchValue)){
          items.push(value)
        }
      })
      items.sort(sortItems)
      return items
    }

    function sortItems(a, b){
      var value = 0
      switch(a.type){
        case "Heading":
          value-=60
          break
        case "Company":
          value-=50
          break
        case "Contact":
          value-=40
          break
        case "Person":
          value-=30
          break
        case "Vacancy":
          value-=20
          break
        case "Placement":
          value-=10
          break
      }
      switch(b.type){
        case "Heading":
          value+=60
          break
        case "Company":
          value+=50
          break
        case "Contact":
          value+=40
          break
        case "Person":
          value+=30
          break
        case "Vacancy":
          value+=20
          break
        case "Placement":
          value+=10
          break
      }
      value+=a.name.localeCompare(b.name)
      return value
    }

    function add(objectID, type, name, parentID, suppressToast){

      var objectID = objectID || "",
        name = name || "",
        parentID = parentID || ""
    
      return ApiSvc.exec({}, "call/NetOwnerFavouritesAdd", {pObjectID:objectID, pType:type, pName:name, pParentID:parentID})
      .then(function(res){
        if(!suppressToast){
          toastSvc.success("Added "+(type==="Heading"?"folder ":"")+name+" to favourites")
        }
      })
    }

    function remove(item, undoCallback){
      return ApiSvc.exec({}, "call/NetOwnerFavouritesRemove", {pID:item.id})
      .then(function(res){
        toastSvc.danger("Removed "+(item.type==="Heading"?"folder ":"")+item.name+" from favourites", function(){undoRemove(item, undoCallback)})
      })
    }

    function undoRemove(item, undoCallback){
      add(item.objectID, item.type, item.description, item.parentID, true)
      .then(undoCallback)
    }
    
  }

})()